import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'customValidationError',
})
export class CustomValidationErrorPipe implements PipeTransform {
  transform(errors: ValidationErrors | null): object {
    if (!errors) {
      return null;
    }

    const errorField: string = Object.keys(errors).find((key: string) => Boolean(errors[key]['message']));

    return errors[errorField];
  }
}
